import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import './ChangeOrderTaskModal.css';
import { getCurrentTask } from 'selectors/admin/work-orders/details/details';
import { getShowChangeOrderTaskModal } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import {
  setShowChangeOrderTaskModal,
  createChangeOrderTask,
  editChangeOrderTask,
} from 'components/admin/work-orders/details/change-order-tasks/store/actions';
import ChangeOrderTaskForm from 'components/admin/work-orders/details/change-order-tasks/ChangeOrderTaskForm';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';

class ChangeOrderTaskModal extends Component {
  handleClose = () => {
    this.props.dispatch(setShowChangeOrderTaskModal());
  };

  setImagesToDestroy = (values) => {
    values.imagesToDestroy = this.changeOrderTask.images
      .map(function (img) {
        let prevImg = values.images.find((i) => i.id === img.id);
        return !prevImg && img;
      })
      .filter((img) => img);
  };

  handleOnSubmit = (values) => {
    if (this.edit) {
      this.setImagesToDestroy(values);
      this.props.dispatch(editChangeOrderTask(this.changeOrderTask.id, values));
    } else {
      if (!this.props.currentTask.awardedContractor) {
        values.changeOrderQuote = true;
      }
      this.props.dispatch(
        createChangeOrderTask(this.props.currentTask.id, values)
      );
    }
  };

  render() {
    this.changeOrderTask = this.props.changeOrderTasks.find(
      (cot) =>
        cot.task_id === this.props.currentTask.id && cot.status === 'pending'
    );
    this.edit = !!this.changeOrderTask;

    if (this.edit) {
      this.initialValues = {
        completionDate: this.changeOrderTask.completion_date,
        description: this.changeOrderTask.description,
        images: this.changeOrderTask.images.map((i) => {
          return { id: i.id, url: i.image.preview.url };
        }),
      };
    }

    return (
      <div>
        <FormModal
          className="change-order-task-modal"
          show={this.props.show}
          title={this.edit ? 'Edit Change Order' : 'Create Change Order'}
          onClose={this.handleClose}
        >
          <ChangeOrderTaskForm
            initialValues={this.initialValues}
            onSubmit={this.handleOnSubmit}
          />
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentTask: getCurrentTask(state),
    show: getShowChangeOrderTaskModal(state),
    changeOrderTasks: getChangeOrderTasks(state),
  };
})(ChangeOrderTaskModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-tasks/ChangeOrderTaskModal.js